/* VCTparts product bundle (snippets/henk-bundle.liquid). Moved out of the
   snippet so the browser caches it; icons and the shop's language prefix
   come from the #hb-config JSON block, texts from #hb-i18n. */
document.addEventListener('DOMContentLoaded', function () {
  const wrapper   = document.querySelector('.hb-wrapper');
  if (!wrapper) return;

  let HB_CONFIG = {};
  try { HB_CONFIG = JSON.parse(document.getElementById('hb-config').textContent) || {}; } catch (e) { HB_CONFIG = {}; }
  const ICON = HB_CONFIG.icons || {};

  const grid      = document.getElementById('hb-upsell-grid');
  const footer    = document.getElementById('hb-footer');
  const btn       = document.getElementById('hb-btn');
  const totalNew  = document.getElementById('hb-total-new');
  const totalOld  = document.getElementById('hb-total-old');
  const altPanel  = document.getElementById('hb-alt-panel');
  const altScroll = document.getElementById('hb-alt-scroll');
  const altClose  = document.getElementById('hb-alt-close');
  const altPrev   = document.getElementById('hb-alt-prev');
  const altNext   = document.getElementById('hb-alt-next');
  const baseUrl   = wrapper.dataset.url;
  const compUrl   = baseUrl + '&intent=complementary';

  const MAIN_PRODUCT_ID = String(wrapper.dataset.mainProduct || '');
  const MAIN_VENDOR     = wrapper.dataset.mainVendor || '';

  /* Vertalingen (uit #hb-i18n) */
  let I18N = {};
  try { I18N = JSON.parse(document.getElementById('hb-i18n').textContent) || {}; } catch (e) { I18N = {}; }
  const t = k => (I18N[k] == null ? k : I18N[k]);
  /* Taalprefix voor productlinks (bijv. "/fr") */
  const ROOT = String(HB_CONFIG.root || '/').replace(/\/$/, '');
  /* Nederlandse config-handle → handle in de huidige winkeltaal (uit #hb-handle-map) */
  let HANDLE_MAP = {};
  try { HANDLE_MAP = JSON.parse(document.getElementById('hb-handle-map').textContent) || {}; } catch (e) { HANDLE_MAP = {}; }
  const loc = h => HANDLE_MAP[h] || h;

  /* ─────────────────────────────────────────────────────────────
     CONFIG — categorieën waar meerdere varianten samen logisch zijn.
     Onderbouwd met je eigen ordersdata (H7+H4, H7+H1, koplamp+T10,
     raamfolie 15%+5%, detailingflesjes). Staat een collectie hier NIET
     in, dan geldt "solo": de eigen categorie wordt volledig uitgesloten
     en de bundel vult met de accessoire-laag eromheen.
     ───────────────────────────────────────────────────────────── */
  const SET_COLLECTIONS = new Set([
    // verlichting — sterkste bewezen combinaties in de winkel
    'verlichting', 'groot-dimlicht', 'mistlicht', 'ledbars', 'verlichting-montage',
    'dagrijverlichting-richtingaanwijzers', 'kenteken-interieurverlichting',
    'rem-achterlicht', 'reflectoren-gevarenlichten', 'lamp-tintfolie',
    'blauwe-zwaailichten', 'magneetzwaailicht', 'buiszwaailicht',
    'batterij-zwaailicht', 'signaalbalken', 'raamflitser', 'grillflisters',
    // folie
    'raam-tintfolie', 'folie-tools', 'plastidip',
    // detailing / onderhoud
    'alle-flesjes', 'detailing', 'detailing-interieur', 'detailing-exterieur',
    'detailing-accessoires', 'detailing-jerrycans', 'detailing-combideals',
    'glossio', 'handschoenen', 'geuren-luchtverfrissers', 'additieven',
    // winter & verbruiksartikelen
    'sneeuw-vorst', 'sneeuwkettingen', 'ruitenwissers', 'luchtfilters'
  ].map(loc));

  /* Aanvullende collecties die (nog) NIET in het navigatiemenu staan.
     Alles wat wél in het menu staat wordt automatisch afgeleid uit de
     categorieboom hierboven — daar hoef je hier niks voor te doen.
     Zet je 'Verlichting Montage & Adapters' in je menu onder Verlichting,
     dan mag deze hele lijst leeg. */
  const EXTRA_COMPANIONS = {
    'groot-dimlicht'                      : ['verlichting-montage'],
    'mistlicht'                           : ['verlichting-montage'],
    'dagrijverlichting-richtingaanwijzers': ['verlichting-montage'],
    'kenteken-interieurverlichting'       : ['verlichting-montage'],
    'rem-achterlicht'                     : ['verlichting-montage'],
    'ledbars'                             : ['verlichting-montage'],
    'verlichting-montage'                 : ['groot-dimlicht', 'dagrijverlichting-richtingaanwijzers']
  };
  Object.keys(EXTRA_COMPANIONS).forEach(k => {
    const v = EXTRA_COMPANIONS[k].map(loc);
    delete EXTRA_COMPANIONS[k];
    EXTRA_COMPANIONS[loc(k)] = v;
  });

  /* Categorieboom uit het navigatiemenu → opzoektabel met ouder, kinderen
     en broertjes per collectie. Broertjes onder dezelfde ouder zijn per
     definitie aanvullende producten: SD-kaarten en voedingskabels naast
     dashcams, stadslicht en kentekenverlichting naast koplampen. */
  const NODE = {};
  (function indexTaxonomy() {
    let tree = [];
    try {
      const el = document.getElementById('hb-taxonomy');
      if (el) tree = JSON.parse(el.textContent) || [];
    } catch (e) { tree = []; }
    (function walk(list, parent) {
      const handles = list.map(n => n.h);
      list.forEach(n => {
        NODE[n.h] = {
          h        : n.h,
          parent   : parent,
          children : (n.c || []).map(x => x.h),
          siblings : handles.filter(x => x !== n.h)
        };
        walk(n.c || [], n.h);
      });
    })(tree, null);
  })();

  function nodeDepth(h) {
    let d = 0, cur = NODE[h];
    while (cur && cur.parent) { d++; cur = NODE[cur.parent]; }
    return d;
  }

  // Hoofdcategorie (bovenste laag van het menu) waar een collectie onder valt.
  function rootOf(h) {
    let cur = NODE[h];
    if (!cur) return null;
    while (cur.parent && NODE[cur.parent]) cur = NODE[cur.parent];
    return cur.h;
  }

  // Alle collecties van het product, ook de te grote — nodig om te wegen
  // in welke tak van het menu het product écht thuishoort.
  function rawHandles() {
    return (wrapper.dataset.cats || '').split('|').map(chunk => {
      const i = chunk.lastIndexOf(':');
      return (i < 0 ? chunk : chunk.slice(0, i)).trim();
    }).filter(Boolean);
  }

  /* Fittingcodes uit de titel. Een H7 naast een H7 is geen bundel maar een
     concurrent, dus alles met dezelfde fitting als het hoofdproduct valt af.
     H4, H1, HB3 en T10 blijven wel staan — dat zijn je best verkopende
     combinaties. Heeft het hoofdproduct geen fittingcode (folie, detailing),
     dan doet deze filter niets. */
  const FITTING_RE = /\b(H1|H3|H4|H7|H8|H9|H11|H13|H15|H16|H18|H19|HB3|HB4|HB5|HIR2|9005|9006|9012|D1S|D1R|D2S|D2R|D3S|D4S|T10|T15|W5W|W16W|P21W|PY21W|BA15S|BAU15S|BAY15D|C5W|H21W)\b/g;

  function fittingsOf(title) {
    const m = String(title || '').toUpperCase().match(FITTING_RE);
    return m ? new Set(m) : new Set();
  }

  // Collecties die nooit als categorie tellen.
  const BLOCK_HANDLES = new Set([
    'alle-producten', 'all', 'aanbiedingen', 'eol',
    'orderly-emails-recommended-products',
    'achteruitrijcameras-sensoren'   // vangnet: was een kapotte mega-collectie
  ].map(loc));
  const BLOCK_PATTERNS = [/^\d+(-\d+)?$/, /^\d+x\d+$/i, /^orderly/i, /^nada/i, /^tryon/i, /^all-products/i];

  const MAX_CAT       = 700;   // groter dan dit is geen bruikbare categorie
  const MAX_EXCLUDE   = 300;   // grotere "eigen categorie" niet uitsluiten (te breed + te zwaar)
  const TARGET_POOL   = 36;    // streefaantal producten voor "Kies een alternatief"

  /* ---- Bundel-kortingsregel (trap): #1 = 0%, #2 = 5%, #3+ = 10% ---- */
  function tierPct(rankIndex) {
    if (rankIndex <= 0) return 0;
    if (rankIndex === 1) return 5;
    return 10;
  }

  let cartBundleUnitPrices = [];

  // Variant-whitelist van dit product.
  let MAIN_VARIANT_IDS = [];
  try {
    const el = document.getElementById('hb-main-variants');
    if (el) MAIN_VARIANT_IDS = JSON.parse(el.textContent) || [];
  } catch (e) { MAIN_VARIANT_IDS = []; }

  function isOwnVariant(id) {
    if (!id) return false;
    if (!MAIN_VARIANT_IDS.length) return String(id) === String(wrapper.dataset.mainVariant || '');
    return MAIN_VARIANT_IDS.indexOf(String(id)) !== -1;
  }

  // Geeft altijd een variant van DIT product terug, nooit die van een aanbeveling.
  function getMainVariantId() {
    const fields = document.querySelectorAll('form[action*="/cart/add"] [name="id"]');
    for (const el of fields) {
      if (el.value && isOwnVariant(el.value)) return parseInt(el.value);
    }
    const fallback = parseInt(wrapper.dataset.mainVariant);
    return fallback || null;
  }

  function getMainPrice() {
    return parseInt(wrapper.dataset.mainPrice) || 0;
  }

  let allCards = [];
  let slotData = [-1, -1, -1, -1, -1];

  // NL/DE: 12,50 / 12,-   FR: 12,50 / 12,00  (zelfde notatie als henk-upsell-products)
  const ROUND_SUFFIX = I18N.roundSuffix != null ? String(I18N.roundSuffix) : ',-';
  function money(cents) {
    const n = parseInt(cents);
    if (!n || isNaN(n)) return '';
    return (n / 100).toFixed(2).replace('.', ',').replace(/,00$/, ROUND_SUFFIX);
  }

  function esc(s) {
    return (s == null ? '' : String(s))
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function handleize(s) {
    return (s || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function updateAltArrows() {
    if (!altPrev || !altNext) return;
    altPrev.disabled = altScroll.scrollLeft <= 0;
    altNext.disabled = altScroll.scrollLeft + altScroll.clientWidth >= altScroll.scrollWidth - 1;
  }

  if (altPrev) altPrev.addEventListener('click', () => altScroll.scrollBy({ left: -240, behavior: 'smooth' }));
  if (altNext) altNext.addEventListener('click', () => altScroll.scrollBy({ left: 240, behavior: 'smooth' }));
  altScroll.addEventListener('scroll', updateAltArrows);

  function computeDiscounts() {
    const participants = [];

    cartBundleUnitPrices.forEach(p => participants.push({ price: p, kind: 'cart' }));
    participants.push({ price: getMainPrice(), kind: 'main' });

    grid.querySelectorAll('.hb-card').forEach(card => {
      if (card.querySelector('.hb-checkbox')?.checked) {
        participants.push({ price: parseInt(card.dataset.base) || 0, kind: 'card', el: card });
      }
    });

    participants
      .map((p, i) => ({ p, i }))
      .sort((a, b) => (b.p.price - a.p.price) || (a.i - b.i))
      .forEach((entry, rank) => { entry.p.pct = tierPct(rank); });

    return participants;
  }

  function buildCard(d, slotIndex) {
    const base = parseInt(d.price) || 0;
    const card = document.createElement('div');
    card.className = 'hb-card is-checked';
    card.dataset.variantId = d.variantId;
    card.dataset.base      = base;
    card.dataset.price     = base;
    card.dataset.oldPrice  = base;

    card.innerHTML = `
      <div class="hb-card-top">
        <label class="hb-custom-checkbox" onclick="event.stopPropagation()">
          <input type="checkbox" class="hb-checkbox" checked aria-label="${esc(d.title)}">
          <span class="hb-checkmark">${ICON.check}</span>
        </label>
        <span class="hb-discount-badge vct-badge vct-badge--danger" style="display:none;">-0%</span>
      </div>
      <img class="hb-card-img" src="${esc(d.img)}" alt="${esc(d.title)}">
      <div class="hb-card-body-wrap">
        <span class="hb-card-vendor">${esc(d.vendor)}</span>
        <span class="hb-card-title">${esc(d.title)}</span>
        <div class="hb-card-prices">
          <span class="hb-price-current">${money(base)}</span>
          <span class="hb-price-old" style="display:none;"></span>
        </div>
        <button type="button" class="hb-alt-btn vct-btn vct-btn--ghost">${esc(t('pickAlt'))}${ICON.chevron}</button>
      </div>
      <span class="hb-discount-badge hb-discount-badge--abs vct-badge vct-badge--danger" style="display:none;">-0%</span>
      <a class="hb-info-btn" href="${esc(d.url)}" target="_blank" title="${esc(t('viewProduct'))}" aria-label="${esc(t('moreInfo'))}">${ICON.info}</a>`;

    card.querySelector('.hb-alt-btn').addEventListener('click', e => {
      e.stopPropagation();
      showAltPanel(slotIndex);
    });
    card.querySelector('.hb-info-btn').addEventListener('click', e => e.stopPropagation());
    card.querySelector('.hb-checkbox').addEventListener('change', function () {
      card.classList.toggle('is-checked', this.checked);
      updateTotals();
    });
    card.addEventListener('click', function (e) {
      if (e.target.closest('.hb-alt-btn')) return;
      if (e.target.closest('.hb-info-btn')) return;
      const cb = this.querySelector('.hb-checkbox');
      cb.checked = !cb.checked;
      this.classList.toggle('is-checked', cb.checked);
      updateTotals();
    });
    return card;
  }

  /* Volgorde in "Kies een alternatief" voor één plek: eerst het gekozen
     product, dan producten uit dezelfde categorie (een andere fitting of
     uitvoering van hetzelfde soort product), dan dezelfde fitting of hetzelfde
     merk, en binnen elke groep de prijs die het dichtst bij de huidige ligt.
     Zo staan de logische vervangers bovenaan in plaats van een willekeurige mix. */
  function altOrder(slotIndex) {
    const cur = allCards[slotData[slotIndex]] || {};
    const curPrice = parseInt(cur.price) || 0;
    const curFits = fittingsOf(cur.title);
    const curVendor = (cur.vendor || '').toLowerCase();
    function score(d) {
      let s = 0;
      if (cur._src && d._src === cur._src) s -= 1000;
      if (curFits.size) { for (const f of fittingsOf(d.title)) { if (curFits.has(f)) { s -= 300; break; } } }
      if (curVendor && (d.vendor || '').toLowerCase() === curVendor) s -= 100;
      return s + Math.min(99, Math.abs((parseInt(d.price) || 0) - curPrice) / 100);
    }
    return allCards
      .map((d, i) => ({ d, i, s: slotData[slotIndex] === i ? -1e9 : score(d) }))
      .filter(x => !slotData.some((idx, s) => idx === x.i && s !== slotIndex))
      .sort((a, b) => (a.s - b.s) || (a.i - b.i));
  }

  function showAltPanel(slotIndex) {
    altScroll.innerHTML = '';
    altPanel.dataset.slot = slotIndex;
    altOrder(slotIndex).forEach(({ d, i }) => {
      const isCurrent = slotData[slotIndex] === i;
      const card = document.createElement('div');
      card.className = 'hb-alt-card' + (isCurrent ? ' hb-alt-card--active' : '');
      card.innerHTML = `
        <img src="${esc(d.img)}" alt="${esc(d.title)}">
        <span class="hb-alt-vendor">${esc(d.vendor)}</span>
        <span class="hb-alt-title">${esc(d.title)}</span>
        <div class="hb-alt-prices">
          <span class="hb-price-current">${money(d.price)}</span>
        </div>`;
      if (!isCurrent) {
        card.addEventListener('click', () => swapSlot(slotIndex, i));
        // Ook met het toetsenbord te kiezen (Enter/spatie), net als een knop.
        card.tabIndex = 0;
        card.setAttribute('role', 'button');
        card.addEventListener('keydown', e => {
          if (e.key !== 'Enter' && e.key !== ' ') return;
          e.preventDefault();
          swapSlot(slotIndex, i);
          const again = grid.querySelectorAll('.hb-card')[slotIndex]?.querySelector('.hb-alt-btn');
          if (again) again.focus();
        });
      }
      altScroll.appendChild(card);
    });
    altPanel.style.display = 'block';
    setTimeout(updateAltArrows, 50);
  }

  function swapSlot(slotIndex, newCardIndex) {
    const cards = grid.querySelectorAll('.hb-card');
    const wasChecked = cards[slotIndex]?.querySelector('.hb-checkbox')?.checked ?? true;
    slotData[slotIndex] = newCardIndex;
    const newCard = buildCard(allCards[newCardIndex], slotIndex);
    if (!wasChecked) { newCard.classList.remove('is-checked'); newCard.querySelector('.hb-checkbox').checked = false; }
    if (cards[slotIndex]) cards[slotIndex].replaceWith(newCard);
    altPanel.style.display = 'none';
    updateTotals();
  }

  altClose.addEventListener('click', () => altPanel.style.display = 'none');

  function setCardDiscount(card, base, pct) {
    const disc = Math.round(base * (100 - pct) / 100);
    card.dataset.price    = pct > 0 ? disc : base;
    card.dataset.oldPrice = base;

    const cur = card.querySelector('.hb-price-current');
    if (cur) cur.textContent = money(pct > 0 ? disc : base);

    const old = card.querySelector('.hb-price-old');
    if (old) {
      if (pct > 0) { old.textContent = money(base); old.style.display = ''; }
      else { old.textContent = ''; old.style.display = 'none'; }
    }

    card.querySelectorAll('.hb-discount-badge').forEach(b => {
      b.textContent = '-' + pct + '%';
      b.style.display = pct > 0 ? '' : 'none';
    });
  }

  function updateMainDisplay(base, pct) {
    const priceEl = wrapper.querySelector('.hb-main-price');
    if (!priceEl) return;
    const disc = Math.round(base * (100 - pct) / 100);
    let oldEl = wrapper.querySelector('.hb-main-price-old');

    if (pct > 0) {
      priceEl.textContent = money(disc);
      if (!oldEl) {
        oldEl = document.createElement('span');
        oldEl.className = 'hb-main-price-old';
        priceEl.after(oldEl);
      }
      oldEl.textContent = money(base);
      oldEl.style.display = '';
    } else {
      priceEl.textContent = money(base);
      if (oldEl) oldEl.style.display = 'none';
    }
  }

  function updateTotals() {
    const participants = computeDiscounts();

    let mainPct = 0;
    participants.forEach(p => { if (p.kind === 'main') mainPct = p.pct; });

    grid.querySelectorAll('.hb-card').forEach(card => {
      const base = parseInt(card.dataset.base) || 0;
      const checked = card.querySelector('.hb-checkbox')?.checked;
      let pct = 0;
      if (checked) {
        const part = participants.find(p => p.el === card);
        pct = part ? part.pct : 0;
      }
      setCardDiscount(card, base, pct);
    });

    const mainBase = getMainPrice();
    const mainDisc = Math.round(mainBase * (100 - mainPct) / 100);
    updateMainDisplay(mainBase, mainPct);

    let newTotal = mainDisc;
    let oldTotal = mainBase;
    let any = false;

    grid.querySelectorAll('.hb-card').forEach(card => {
      if (card.querySelector('.hb-checkbox')?.checked) {
        newTotal += parseInt(card.dataset.price) || 0;
        oldTotal += parseInt(card.dataset.oldPrice) || 0;
        any = true;
      }
    });

    footer.style.display = any ? 'flex' : 'none';
    if (any) {
      totalNew.textContent = money(newTotal);
      totalOld.textContent = oldTotal > newTotal ? money(oldTotal) : '';
    }
  }

  /* ─────────── Databronnen ─────────── */

  function parseSourceCards(html) {
    const el = document.createElement('div');
    el.innerHTML = html;
    return Array.from(el.querySelectorAll('.hb-source-card')).map(src => ({
      productId : String(src.dataset.productId || ''),
      variantId : src.dataset.variantId,
      price     : src.dataset.price,
      title     : src.dataset.title,
      vendor    : src.dataset.vendor,
      url       : src.dataset.url,
      img       : src.dataset.img
    }));
  }

  function loadRecs(url) {
    return fetch(url).then(r => r.text()).then(parseSourceCards).catch(() => []);
  }

  function cardFromJson(p) {
    if (!p || String(p.id) === MAIN_PRODUCT_ID) return null;
    const v = (p.variants || []).find(x => x.available !== false) || (p.variants || [])[0];
    if (!v || v.available === false) return null;
    const cents = Math.round(parseFloat(v.price) * 100);
    if (!cents) return null;
    let img = '';
    if (p.images && p.images[0]) img = (typeof p.images[0] === 'string') ? p.images[0] : p.images[0].src;
    return {
      productId : String(p.id),
      variantId : String(v.id),
      price     : String(cents),
      title     : p.title,
      vendor    : p.vendor,
      url       : ROOT + '/products/' + p.handle,
      img       : img
    };
  }

  function fetchCollectionPage(handle, page) {
    return fetch('/collections/' + handle + '/products.json?limit=250&page=' + (page || 1))
      .then(r => r.ok ? r.json() : { products: [] })
      .then(j => j.products || [])
      .catch(() => []);
  }

  function fetchCollectionCards(handle) {
    return fetchCollectionPage(handle, 1).then(ps => ps.map(cardFromJson).filter(Boolean));
  }

  // Product-ID's van de eigen categorie, om concurrenten uit te sluiten.
  function fetchCategoryIds(handle, count) {
    const pages = Math.min(2, Math.max(1, Math.ceil((count || 0) / 250)));
    const jobs = [];
    for (let p = 1; p <= pages; p++) jobs.push(fetchCollectionPage(handle, p));
    return Promise.all(jobs).then(lists => {
      const ids = new Set();
      lists.forEach(list => list.forEach(p => ids.add(String(p.id))));
      return ids;
    }).catch(() => new Set());
  }

  // Categoriecollecties van dit product, klein naar groot, junk eruit.
  function parseCats() {
    const vendorHandle = handleize(MAIN_VENDOR);
    return (wrapper.dataset.cats || '').split('|').map(chunk => {
      const i = chunk.lastIndexOf(':');
      if (i < 0) return null;
      return { handle: chunk.slice(0, i).trim(), count: parseInt(chunk.slice(i + 1)) || 0 };
    })
    .filter(Boolean)
    .filter(c => c.handle && c.count > 1 && c.count <= MAX_CAT)
    .filter(c => !BLOCK_HANDLES.has(c.handle))
    .filter(c => !BLOCK_PATTERNS.some(re => re.test(c.handle)))
    .filter(c => c.handle !== vendorHandle)
    .sort((a, b) => a.count - b.count);
  }

  function loadCartBundle() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(r => r.json())
      .then(cart => {
        cartBundleUnitPrices = [];
        (cart.items || []).forEach(line => {
          const props = line.properties || {};
          const isBundle = props._bundle === 'true' || props._bundle === true ||
                           props._upsell === 'true' || props._upsell === true;
          if (!isBundle) return;
          const unit = parseInt(line.original_price != null ? line.original_price : line.price) || 0;
          const qty = parseInt(line.quantity) || 0;
          for (let q = 0; q < qty; q++) cartBundleUnitPrices.push(unit);
        });
      })
      .catch(() => { cartBundleUnitPrices = []; });
  }

  /* ─────────── Samenstellen van de bundel ─────────── */
  (async function init() {
    const isGlossio = MAIN_VENDOR && MAIN_VENDOR.toLowerCase() === 'glossio';
    const seen = new Set();

    function add(list, rank, src) {
      for (const d of list) {
        if (!d || !d.variantId) continue;
        if (src && !d._src) d._src = src;
        if (d.productId && d.productId === MAIN_PRODUCT_ID) continue;
        if (isOwnVariant(d.variantId)) continue;
        if (seen.has(d.variantId)) continue;
        seen.add(d.variantId);
        d._rank = rank;
        allCards.push(d);
      }
    }

    await loadCartBundle();

    // 0. Voorkeur: metaveld custom.aanvullingen of de decoder bij een LED-lamp (#hb-preferred). Nooit filteren.
    let preferred = [];
    try { preferred = JSON.parse((document.getElementById('hb-preferred') || {}).textContent || '[]') || []; } catch (e) { preferred = []; }
    add(preferred.map(d => Object.assign({}, d, { variantId: String(d.variantId), productId: String(d.productId || '') })), -1, 'pref');

    if (isGlossio) {
      // Glossio werkte al goed: alleen Glossio-producten, 5 kaarten.
      add(await loadRecs(compUrl), 0, 'comp');
      add(await fetchCollectionCards(loc('glossio')), 1, 'glossio');
      allCards = allCards.filter(d => (d.vendor || '').toLowerCase() === 'glossio');
    } else {
      const cats     = parseCats();
      const setCats  = cats.filter(c => SET_COLLECTIONS.has(c.handle));
      const restCats = cats.filter(c => !SET_COLLECTIONS.has(c.handle));

      let blockIds = new Set();
      const sources = [];
      const pushSource = h => { if (h && sources.indexOf(h) === -1) sources.push(h); };

      /* Zoek de plek van dit product in de categorieboom: de DIEPSTE
         menu-collectie waar het in zit. Voor een dashcam is dat "Dashcams"
         (onder Interieur > Dashcam & Toebehoren), voor een H7-koplamp
         "Groot- & Dimlicht" (onder Verlichting). */
      /* Een product kan in meerdere takken van het menu zitten. Kies de tak
         waar de MEESTE collecties van dit product onder vallen, en pas daarna
         de diepste. Zo wint Verlichting (groot-dimlicht + verlichting = 2)
         het van een losse verdwaalde collectie in een andere tak. Dat is wat
         er misging: door het woord "Turbo" in de titel belandde een koplamp
         in Motorisch, en dan krijg je acculaders in je bundel. */
      const branchScore = {};
      rawHandles().forEach(h => {
        const r = rootOf(h);
        if (r) branchScore[r] = (branchScore[r] || 0) + 1;
      });

      const candidates = cats.map(c => c.handle).filter(h => NODE[h]);
      candidates.sort((a, b) =>
        ((branchScore[rootOf(b)] || 0) - (branchScore[rootOf(a)] || 0)) ||
        (nodeDepth(b) - nodeDepth(a))
      );
      const node = candidates.length ? NODE[candidates[0]] : null;

      if (node) {
        const isSet = SET_COLLECTIONS.has(node.h);

        if (isSet) {
          // Broertjes binnen de eigen categorie mogen: een H7 naast een H4 of
          // H1 is aantoonbaar je beste combinatie. De fittingfilter hieronder
          // haalt de echte concurrenten (H7 naast H7) er alsnog uit.
          pushSource(node.h);
        } else {
          // Eenmalige aankoop per auto: eigen categorie volledig uitsluiten.
          const own = cats.find(c => c.handle === node.h);
          if (own && own.count <= MAX_EXCLUDE) blockIds = await fetchCategoryIds(own.handle, own.count);
        }

        (EXTRA_COMPANIONS[node.h] || []).forEach(pushSource);
        node.children.forEach(pushSource);
        node.siblings.forEach(pushSource);
        if (node.parent) pushSource(node.parent);
      } else {
        /* Product staat niet in het menu. Terugvallen op collectiegrootte:
           kleinste eigen categorie = concurrenten, de rest is de vulling.
           Bewust niet andersom sorteren — een H7 zit door het woord "Turbo"
           ook in motor-turbo (71), kleiner dan groot-dimlicht (166). */
        if (setCats.length) {
          setCats.forEach(c => pushSource(c.handle));
          setCats.forEach(c => (EXTRA_COMPANIONS[c.handle] || []).forEach(pushSource));
          restCats.forEach(c => pushSource(c.handle));
        } else {
          const leaf = cats[0] || null;
          if (leaf && leaf.count <= MAX_EXCLUDE) blockIds = await fetchCategoryIds(leaf.handle, leaf.count);
          cats.slice(1).forEach(c => pushSource(c.handle));
        }
      }

      /* Zelfde fitting als het hoofdproduct = concurrent, niet aanvullend.
         Dit is waarom je geen tweede H7 meer ziet naast je H7. */
      const mainFits = fittingsOf(wrapper.dataset.mainTitle || '');
      function keep(d) {
        if (d.productId && blockIds.has(d.productId)) return false;
        if (mainFits.size) {
          for (const f of fittingsOf(d.title)) if (mainFits.has(f)) return false;
        }
        return true;
      }

      // 1. Handmatig ingesteld in Search & Discovery — nooit filteren.
      add(await loadRecs(compUrl), 0, 'comp');

      // 2. Alle bronnen ophalen en daarna om-en-om mengen, zodat de vier
      //    zichtbare kaartjes een mix zijn (adapter, stadslicht, andere
      //    fitting) in plaats van vier keer hetzelfde soort product.
      const buckets = [];
      let gathered = 0;
      for (const handle of sources) {
        if (gathered >= TARGET_POOL) break;
        const b = (await fetchCollectionCards(handle)).filter(keep);
        b.forEach(d => { d._src = handle; });
        if (b.length) { buckets.push(b); gathered += b.length; }
      }
      const merged = [];
      for (let i = 0; merged.length < TARGET_POOL; i++) {
        let added = false;
        for (const b of buckets) {
          if (!b[i]) continue;
          merged.push(b[i]);
          added = true;
          if (merged.length >= TARGET_POOL) break;
        }
        if (!added) break;
      }
      add(merged, 10);

      // 3. Laatste redmiddel: Shopify's gewone aanbevelingen.
      if (allCards.length < 4) add((await loadRecs(baseUrl)).filter(keep), 99, 'recs');

      // Binnen dezelfde rang: goedkoper dan het hoofdproduct eerst — een
      // duurder product hoort niet als add-on in een bundel.
      const mp = getMainPrice();
      allCards.sort((a, b) =>
        (a._rank - b._rank) ||
        ((parseInt(a.price) <= mp ? 0 : 1) - (parseInt(b.price) <= mp ? 0 : 1))
      );
    }

    if (allCards.length === 0) { wrapper.style.display = 'none'; return; }

    const maxSlots = isGlossio ? 5 : 4;
    const count = Math.min(maxSlots, allCards.length);
    grid.innerHTML = '';
    for (let i = 0; i < count; i++) {
      slotData[i] = i;
      grid.appendChild(buildCard(allCards[i], i));
    }
    updateTotals();
  })();

  /* ─────────── Winkelwagen ─────────── */

  function updateCartCount(cart, sideCartDoc) {
    const totalQty = sideCartDoc?.querySelector('[data-totalqty]')?.dataset.totalqty || cart.item_count;
    const totalPrice = sideCartDoc?.querySelector('[data-totalprice]')?.dataset.totalprice;
    document.querySelectorAll('#cart-count,[data-cart-count],[data-cart-item-count],.cart-count,.cart__count,.header__cart-count,.cart-count-bubble').forEach(el => {
      el.textContent = totalQty;
      el.setAttribute('data-count', totalQty);
      if (parseInt(totalQty, 10) > 0) el.removeAttribute('hidden');
    });
    if (totalPrice) {
      document.querySelectorAll('#cart-total,[data-cart-total]').forEach(el => { el.textContent = totalPrice; });
    }
  }

  function refreshDrawerContent(addResponse) {
    const sideCartContainer = document.getElementById('cart');
    const sideCartHtml = addResponse?.sections?.['side-cart'];
    if (!sideCartContainer || !sideCartHtml) return Promise.resolve(null);

    const sideCartDoc = new DOMParser().parseFromString(sideCartHtml, 'text/html');
    const sideCartSection = sideCartDoc.querySelector('#shopify-section-side-cart');
    if (!sideCartSection) return Promise.resolve(null);

    sideCartContainer.innerHTML = sideCartSection.innerHTML;
    window.dispatchEvent(new CustomEvent('modulePanel'));
    window.dispatchEvent(new CustomEvent('listCart'));
    window.dispatchEvent(new CustomEvent('semanticInput'));
    window.dispatchEvent(new CustomEvent('formValidate'));
    window.dispatchEvent(new CustomEvent('accordeon'));
    if (window.ajaxCart && typeof window.ajaxCart.init === 'function') window.ajaxCart.init();
    return Promise.resolve(sideCartDoc);
  }

  function openCartDrawer() {
    if (window.ajaxCart && typeof window.ajaxCart.load === 'function') {
      window.ajaxCart.load(false, true, false, false);
      return;
    }
    const drawerEl = document.querySelector('cart-drawer');
    if (drawerEl) {
      if (typeof drawerEl.open === 'function') { drawerEl.open(); return; }
      drawerEl.setAttribute('open', ''); drawerEl.removeAttribute('aria-hidden'); return;
    }
    for (const sel of ['a[data-panel="cart"]','[data-cart-toggle]','[data-drawer-trigger="cart"]','.js-drawer-open-cart','#cart-icon-bubble','[aria-label*="winkelwagen" i]','.cart-toggle','.cart__toggle','.header__cart','.site-header__cart']) {
      const el = document.querySelector(sel);
      if (el) { el.click(); return; }
    }
    for (const [name, target] of [['CartDrawer:open', document.body],['cart:open', document],['cart:toggle', document],['theme:cart:open', document],['open-cart', document],['cartOpen', document]]) {
      target.dispatchEvent(new CustomEvent(name, { bubbles: true }));
    }
  }

  btn.addEventListener('click', function () {
    const mainVariantId = getMainVariantId();
    const items = [];

    if (mainVariantId) items.push({ id: mainVariantId, quantity: 1, properties: { _bundle: 'true' } });

    grid.querySelectorAll('.hb-card.is-checked').forEach(card => {
      const id = parseInt(card.dataset.variantId);
      if (id && !isNaN(id)) {
        items.push({ id, quantity: 1, properties: { _bundle: 'true' } });
      }
    });

    if (!items.length) return;

    const originalHTML = btn.innerHTML;
    btn.textContent = t('adding');
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        items,
        attributes: { 'henk-bundle': 'true' },
        sections: 'side-cart',
        sections_url: window.location.pathname
      })
    })
    .then(r => {
      if (!r.ok) return r.json().then(e => { throw new Error(e.message || r.status); });
      return r.json();
    })
    .then(addResponse => Promise.all([fetch('/cart.js').then(r => r.json()), refreshDrawerContent(addResponse)]))
    .then(([cart, sideCartDoc]) => {
      updateCartCount(cart, sideCartDoc);
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
      window.dispatchEvent(new CustomEvent('cart-update', { bubbles: true, detail: { cart } }));
      document.dispatchEvent(new CustomEvent('theme:cart:update', { bubbles: true, detail: { cart } }));
      openCartDrawer();
      btn.innerHTML = ICON.check + esc(t('added'));
      setTimeout(() => { btn.innerHTML = originalHTML; btn.disabled = false; }, 2000);
    })
    .catch(err => {
      console.error('Cart fout:', err);
      btn.textContent = t('error') + (err.message || t('retry'));
      setTimeout(() => { btn.innerHTML = originalHTML; btn.disabled = false; }, 3000);
    });
  });
});
